import { render } from "./cis.cattle.io.clusterscanbenchmark.vue?vue&type=template&id=0b571292"
import script from "./cis.cattle.io.clusterscanbenchmark.vue?vue&type=script&lang=js"
export * from "./cis.cattle.io.clusterscanbenchmark.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__